import React, { useState } from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ModuleTabelBox from "./ModuleTabelBox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const SprintTabelBox = ({
  mileStoneName,
  sprintsvalue,
  milestoneIndex,
  sprintIndex,
}) => {
  const [moduleStatus, setModuleStatus] = useState(false);
  const handleSprintClick = () => {
    setModuleStatus(!moduleStatus);
  };
  return (
    <>
      <div  className="sprintboardColumn">
        <div className="mileStone-head">
          {moduleStatus ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          <h3 onClick={() => handleSprintClick()}>{sprintsvalue?.sprints}</h3>
        </div>
        <div></div>
      </div>
      
      {moduleStatus &&
        sprintsvalue?.tasknames
?.map((moduleVal, moduleIndex) => (
          <ModuleTabelBox
            moduleValue={moduleVal}
            moduleIndex={moduleIndex}
            mileStoneName={mileStoneName}
            milestoneIndex={milestoneIndex}
            sprintIndex={sprintIndex}
          />
        ))}
    </>
  );
};

export default SprintTabelBox;
